(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-video-tile"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmVideoInlineBound) return;
    window.__mmVideoInlineBound = true;

    function bindVideoEvents(video) {
      if (video.__mmBound) return;
      video.__mmBound = true;
      var tile = video.closest('[data-mm-video-inline]');
      if (!tile) return;
      video.addEventListener('play', function () { tile.classList.add('is-playing'); });
      video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { tile.classList.remove('is-playing'); });
    }
    document.querySelectorAll('[data-mm-video-inline] video').forEach(bindVideoEvents);

    document.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-mm-video-inline]');
      if (!tile) return;
      var video = tile.querySelector('video');
      if (!video) return;
      e.preventDefault();
      bindVideoEvents(video);
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.pause();
      }
    });

    // Warm-up (2026-08-16): the tiles ship preload="none" so page load stays
    // light, which used to mean the first tap started the download from zero.
    // First hover/touch bumps the inline element to metadata (moov atom only);
    // pointerdown/touchstart upgrades to full buffering — the shopper is
    // committing, so the fetch runs during the tap. No new elements, no cost
    // until a shopper actually reaches for a tile.
    function warmTile(tile, level) {
      var video = tile.querySelector('video');
      if (!video) return;
      if (level === 'auto') {
        if (video.preload !== 'auto') video.preload = 'auto';
      } else if (video.preload === 'none') {
        video.preload = 'metadata';
      }
    }
    document.addEventListener('mouseover', function (e) {
      var tile = e.target.closest && e.target.closest('[data-mm-video-inline]');
      if (tile) warmTile(tile, 'metadata');
    });
    document.addEventListener('touchstart', function (e) {
      var tile = e.target.closest && e.target.closest('[data-mm-video-inline]');
      if (tile) warmTile(tile, 'auto');
    }, { passive: true });
    document.addEventListener('pointerdown', function (e) {
      var tile = e.target.closest && e.target.closest('[data-mm-video-inline]');
      if (tile) warmTile(tile, 'auto');
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-return-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    // Both the sticky bar link and the floating mobile button.
    var links = [].slice.call(document.querySelectorAll('[data-policy-return-link]'));
    var label = document.querySelector('[data-policy-return-label]');
    if (!links.length) return;

    var ref = document.referrer || '';
    var sameOrigin = false;
    var refUrl = null;
    try {
      if (ref) {
        refUrl = new URL(ref);
        sameOrigin = refUrl.origin === window.location.origin
          && refUrl.pathname !== window.location.pathname;
      }
    } catch (e) {}

    if (sameOrigin && refUrl) {
      var href = refUrl.pathname + refUrl.search + refUrl.hash;
      links.forEach(function (l) { l.setAttribute('href', href); });

      var path = refUrl.pathname.replace(/\/+$/, '');
      var segs = path.split('/').filter(Boolean);
      var newLabel = '';

      if (segs[0] === 'products' && segs[1]) {
        newLabel = 'Return to ' + prettify(segs[1]);
      } else if (segs[0] === 'collections' && segs[1] && segs[1] !== 'all') {
        if (segs[2] === 'products' && segs[3]) {
          newLabel = 'Return to ' + prettify(segs[3]);
        } else {
          newLabel = 'Return to ' + prettify(segs[1]);
        }
      } else if (segs[0] === 'collections') {
        newLabel = 'Return to shop';
      } else if (segs[0] === 'cart') {
        newLabel = 'Return to cart';
      } else if (segs[0] === 'blogs' && segs[2]) {
        newLabel = 'Return to ' + prettify(segs[2]);
      } else if (segs[0] === 'pages' && segs[1]) {
        newLabel = 'Return to ' + prettify(segs[1]);
      } else if (segs.length === 0) {
        newLabel = 'Return to home';
      } else {
        newLabel = 'Return to previous page';
      }

      // Only the sticky bar carries the descriptive label; the floating
      // button keeps its short static "Back".
      if (label) label.textContent = newLabel;

      links.forEach(function (l) {
        l.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          if (window.history.length > 1) {
            e.preventDefault();
            window.history.back();
          }
        });
      });
    }

    function prettify(slug) {
      var s = decodeURIComponent(slug).replace(/[-_]+/g, ' ').trim();
      return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
